// src/components/rpa/agent/GovernanceAgentChatMini.js
//
// ⭐ NEW (Aug 2026) — floating launcher for the AI Governance Agent.
//
// Mirrors RpaAgentChatMini.js exactly in structure, but renders the
// governance analyst instead of the audit agent, and takes no doc/project
// context — the governance page has no selected document, and the agent
// reports platform-wide rather than per-engagement.
//
// Mounted from App.js on /rpa/agent-governance ONLY. That route is a prefix
// of /rpa, so App.js must check the governance route BEFORE isRpaRoute or
// this page gets the audit agent instead — which looks correct but hands the
// user an agent whose whole vocabulary is document-oriented.

import React, { useState } from 'react';
import { FaShieldAlt } from 'react-icons/fa';
import GovernanceAgentChatLogic from './GovernanceAgentChatLogic';
import './GovernanceAgentChatMini.css';

const GovernanceAgentChatMini = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`gov-agent-mini ${isOpen ? 'open' : ''}`}>
      {/* Toggle button */}
      <button
        className="gov-agent-toggle"
        onClick={() => setIsOpen(v => !v)}
        title={isOpen ? 'Close Governance Agent' : 'Open Governance Agent'}
      >
        <FaShieldAlt />
        <span className="gov-agent-toggle-label">
          {isOpen ? 'Close' : 'Governance Agent'}
        </span>
      </button>

      {/* Chat panel */}
      {isOpen && (
        <div className="gov-agent-panel">
          <GovernanceAgentChatLogic onClose={() => setIsOpen(false)} />
        </div>
      )}
    </div>
  );
};

export default GovernanceAgentChatMini;